import { Box } from '@mui/material'
import { FarmSelector } from '~/components/farm-selector'
import { FARM_SELECTOR_HIDDEN_ROUTES } from '~/common/constants/route-constants'
import { useFeatures } from '~/common/use-features'

export const MobileExtras = ({ isSuperAdmin, userFarms, location }) => {
  const { features } = useFeatures()

  const showFarmSelector =
    isSuperAdmin && (
      (features['add_farm'] && userFarms?.length > 1) ||
      !FARM_SELECTOR_HIDDEN_ROUTES.includes(location?.pathname)
    )

  return (
    <Box
      sx={{
        display: { xs: 'flex', md: 'none' },
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {showFarmSelector && <FarmSelector />}
    </Box>
  )
}
